<template>
  <button
    v-tooltip.top="`Bold`"
    class="border rounded px-2 flex items-center h-8 cursor-pointer hover:bg-gray-100 bg-white"
    @click="editor?.chain().focus().toggleBold().run()"
  >
    <Icon
      class="h-[20px] w-[20px]"
      name="ic:sharp-format-bold"
    />
  </button>
</template>

<script setup lang="ts">
const editor = defineModel('editor')
</script>
